import { render, staticRenderFns } from "./step3-registerInfo.vue?vue&type=template&id=1248d1a5&scoped=true"
import script from "./step3-registerInfo.vue?vue&type=script&lang=js"
export * from "./step3-registerInfo.vue?vue&type=script&lang=js"
import style0 from "./step3-registerInfo.vue?vue&type=style&index=0&id=1248d1a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1248d1a5",
  null
  
)

export default component.exports